/**
 * Mini-Game Module
 *
 * Provides a simple, extensible system for chess mini-games.
 *
 * ## Usage
 *
 * ```typescript
 * import { MiniGameRegistry, MiniGameParser } from '@shared/minigame';
 *
 * // Parse a PGN with mini-game headers
 * const config = MiniGameParser.extractConfig(pgn);
 *
 * // Create an engine
 * const engine = MiniGameRegistry.createEngine(config);
 *
 * // Play the game
 * const result = engine.makeMove('e4', 'e4'); // For click-based, from === to
 * ```
 *
 * ## Adding a New Mini-Game
 *
 * 1. Create `games/MyNewGame.ts`
 * 2. Extend `MiniGameBase` for your engine
 * 3. Call `MiniGameRegistry.register({...})` with your definition
 * 4. Import in `games/index.ts`
 *
 * See `games/SquareHunt.ts` for a complete example.
 */
// Types
export * from "./types";
// Core
export { MiniGameRegistry } from "./MiniGameRegistry";
export { MiniGameBase } from "./MiniGameBase";
export * as BoardUtils from "./BoardUtils";
// Parser
export { MiniGameParser } from "../pgn/MiniGameParser";
// Import games to register them
import "./games";
// Re-export engines for convenience
export { SquareHuntEngine } from "./games";
